module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted_old-0ef67fbd86c92e4095426a362e63b9c6.png";